// CATÁLOGO INICIAL com os produtos, preços e tecidos fornecidos pela Alexandra (fase 1).
// Todas as peças são feitas por encomenda (sem stock). A loja usa o catálogo publicado pela API quando disponível;
// este ficheiro é o ponto de partida e o plano B. Fotografias em /img/catalog (id "static:pNN"), tecidos em /img/demo.
// Tecidos que não permitem nome personalizado têm noName: true.

// Babetes reversíveis: a cliente escolhe "Sim" (+0,50 €) e passa a escolher também o padrão do verso. A parte "verso" só existe com essa escolha.
export const REVERSIVEL_OPTIONS = [
  {
    "id": "reversivel",
    "label": "Reversível",
    "hint": "Com dois padrões, um de cada lado: usas o babete dos dois lados.",
    "choices": [
      { "id": "nao", "label": "Não, um só padrão", "priceDelta": 0, "textLabel": null, "textMaxLength": 12, "blockedByPattern": false },
      { "id": "sim", "label": "Sim, dois padrões", "priceDelta": 0.5, "textLabel": null, "textMaxLength": 12, "blockedByPattern": false }
    ]
  }
];
// Pack de 4 babetes: cada babete pode ser reversível (+0,50 € por babete) e ter o seu verso.
export const PACK_BIB_OPTIONS = [1, 2, 3, 4].map((n) => ({ id: `reversivel-babete-${n}`, label: `Babete ${n} reversível`, hint: REVERSIVEL_OPTIONS[0].hint, choices: REVERSIVEL_OPTIONS[0].choices }));
export const PACK_BIB_VERSOS = [1, 2, 3, 4].map((n) => ({ id: `babete-${n}-verso`, label: `Babete ${n} · verso`, models: [], patterns: [], suggested: false, suggestions: [], onlyWith: { optionId: `reversivel-babete-${n}`, choiceId: "sim" } }));
export const REVERSIVEL_SLOTS = [
  { "id": "verso", "label": "Verso", "models": [], "patterns": [], "suggested": false, "suggestions": [], "onlyWith": { "optionId": "reversivel", "choiceId": "sim" } }
];

export const categories = [
  {
    "id": "porta-chupetas",
    "name": "Porta-chupetas",
    "shape": "bolsa",
    "pattern": "vichy-azul",
    "intro": "Porta-chupetas em forma de ursinho, em algodão ou impermeável, com o nome do teu bebé."
  },
  {
    "id": "babetes",
    "name": "Babetes",
    "shape": "flor",
    "pattern": "vichy-grande-bege",
    "intro": "Babetes para baba em algodão com interior impermeável."
  },
  {
    "id": "tapa-fraldas",
    "name": "Tapa-fraldas",
    "shape": "tapa",
    "pattern": "musselina-florzinhas",
    "intro": "Tapa-fraldas em tecidos delicados, reversíveis ou de um só padrão."
  },
  {
    "id": "porta-fraldas",
    "name": "Porta-fraldas e documentos",
    "shape": "carteira",
    "pattern": "flores-coloridas",
    "intro": "Porta-fraldas, muda-fraldas portátil e porta-documentos."
  },
  {
    "id": "saquinhos",
    "name": "Saquinhos de roupa",
    "shape": "bolsa",
    "pattern": "vichy-bege",
    "intro": "Saquinhos de roupa forrados e personalizados."
  },
  {
    "id": "coelhinhos",
    "name": "Coelhinhos",
    "shape": "flor",
    "pattern": "vichy-azul",
    "intro": "Coelhinhos com gola em tecido, com o nome na orelha se quiseres."
  }
];

export const patterns = {
  "folhas-azuis": {
    "name": "Folhas azuis",
    "texture": "folhas-azuis"
  },
  "folhas-rosa": {
    "name": "Folhas rosa",
    "texture": "folhas-rosa"
  },
  "florzinhas-rosa": {
    "name": "Florzinhas rosa",
    "texture": "florzinhas-rosa"
  },
  "flores-rosa": {
    "name": "Flores rosa",
    "texture": "flores-rosa"
  },
  "petalas-rosa": {
    "name": "Pétalas rosa",
    "texture": "petalas-rosa"
  },
  "flores-coloridas": {
    "name": "Flores coloridas",
    "texture": "flores-coloridas"
  },
  "flores": {
    "name": "Flores",
    "texture": "flores"
  },
  "vichy-bege": {
    "name": "Vichy bege",
    "texture": "vichy-bege"
  },
  "vichy-grande-bege": {
    "name": "Vichy grande bege",
    "texture": "vichy-grande-bege"
  },
  "vichy-verde-azul": {
    "name": "Vichy verde e azul",
    "texture": "vichy-verde-azul"
  },
  "vichy-verde-tropa": {
    "name": "Vichy verde tropa",
    "texture": "vichy-verde-tropa"
  },
  "vichy-azul": {
    "name": "Vichy azul",
    "texture": "vichy-azul"
  },
  "vichy-rosa": {
    "name": "Vichy rosa",
    "texture": "vichy-rosa"
  },
  "vichy-rosa-claro": {
    "name": "Vichy rosa claro",
    "texture": "vichy-rosa-claro"
  },
  "vichy-cereja": {
    "name": "Vichy cereja",
    "texture": "vichy-cereja"
  },
  "riscas-bege": {
    "name": "Riscas bege",
    "texture": "riscas-bege"
  },
  "riscas-verde": {
    "name": "Riscas verde",
    "texture": "riscas-verde"
  },
  "riscas-finas-azuis": {
    "name": "Riscas finas azuis",
    "texture": "riscas-finas-azuis"
  },
  "riscas-larga-azuis": {
    "name": "Riscas largas azuis",
    "texture": "riscas-larga-azuis"
  },
  "riscas-larga-verde-tropa": {
    "name": "Riscas largas verde tropa",
    "texture": "riscas-larga-verde-tropa"
  },
  "musselina-florzinhas": {
    "name": "Musselina florzinhas",
    "texture": "musselina-florzinhas"
  },
  "musselina-flores": {
    "name": "Musselina flores",
    "texture": "musselina-flores"
  },
  "bordado-branco": {
    "name": "Bordado branco",
    "texture": "bordado-branco",
    "noName": true
  },
  "bordado-bege": {
    "name": "Bordado bege",
    "texture": "bordado-bege",
    "noName": true
  },
  "bordado-ingles": {
    "name": "Bordado inglês",
    "texture": "bordado-ingles",
    "noName": true
  },
  "fio-dourado": {
    "name": "Fio dourado",
    "texture": "fio-dourado"
  },
  "margaridas": {
    "name": "Margaridas",
    "texture": "margaridas"
  },
  "waffle-branco": {
    "name": "Waffle branco",
    "texture": "waffle-branco",
    "noName": true
  },
  "waffle-bege": {
    "name": "Waffle bege",
    "texture": "waffle-bege",
    "noName": true
  },
  "waffle-rosa-bebe": {
    "name": "Waffle rosa bebé",
    "texture": "waffle-rosa-bebe",
    "noName": true
  },
  "imp-flores": {
    "name": "Flores (impermeável)",
    "texture": "imp-flores"
  },
  "imp-bolinhas-castanhas": {
    "name": "Bolinhas castanhas (impermeável)",
    "texture": "imp-bolinhas-castanhas"
  },
  "imp-tulipas": {
    "name": "Tulipas (impermeável)",
    "texture": "imp-tulipas"
  },
  "imp-flores-nuvens": {
    "name": "Flores e nuvens (impermeável)",
    "texture": "imp-flores-nuvens"
  },
  "imp-cogumelos": {
    "name": "Cogumelos (impermeável)",
    "texture": "imp-cogumelos"
  },
  "imp-riscas-colorida": {
    "name": "Riscas coloridas (impermeável)",
    "texture": "imp-riscas-colorida"
  },
  "imp-risca-azul": {
    "name": "Risca azul (impermeável)",
    "texture": "imp-risca-azul"
  },
  "imp-vichy-verde": {
    "name": "Vichy verde (impermeável)",
    "texture": "imp-vichy-verde"
  },
  "imp-brinquedos": {
    "name": "Brinquedos (impermeável)",
    "texture": "imp-brinquedos"
  },
  "algodao-bege": {
    "name": "Bege (algodão)",
    "texture": "algodao-bege"
  },
  "forro-arco-iris": {
    "name": "Arco-íris (forro)",
    "texture": "forro-arco-iris"
  },
  "forro-rosa": {
    "name": "Rosa (forro)",
    "texture": "forro-rosa"
  },
  "forro-animais": {
    "name": "Animais (forro)",
    "texture": "forro-animais"
  }
};

const base = {
  images: [],
  materials: null,
  dimensions: null,
  care: null,
  leadTime: null,
  features: [],
  personalization: null,
  price: null,
  priceIsExample: false,
  featured: false,
};

// Materiais: por omissão 100% algodão; as peças com tecidos impermeáveis (minimat) descrevem o que muda.
const COTTON = "100% algodão";
const MATERIALS = {
  "saquinho-de-roupa": "Exterior em algodão. Interior em algodão ou em minimat impermeável.",
  "pack-3-saquinhos": "Exterior em algodão. Interior em algodão ou em minimat impermeável.",
  "porta-documentos": "Exterior em veludo e interior em algodão. Em minimat impermeável, é sempre por dentro e por fora.",
  "porta-chupetas": "100% algodão ou minimat impermeável.",
};
const materialsOf = (p) => MATERIALS[p.slug] ?? COTTON;

export const products = [
  {
    "slug": "porta-chupetas",
    "name": "Porta-chupetas ursinho",
    "category": "porta-chupetas",
    "shape": "bolsa",
    "description": "Porta-chupetas em forma de ursinho, com fita. Escolhes com ou sem nome no ursinho, o comprimento da fita, o prendedor, se queres nome na fita e como a fita se adapta à chupeta. Feito à mão por mim, por encomenda. Disponível em algodão ou em tecido impermeável. Nos tecidos bordados não é possível colocar nome.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa",
      "musselina-florzinhas",
      "musselina-flores",
      "bordado-branco",
      "bordado-bege",
      "bordado-ingles",
      "fio-dourado",
      "margaridas",
      "imp-flores",
      "imp-bolinhas-castanhas",
      "imp-tulipas",
      "imp-flores-nuvens",
      "imp-cogumelos",
      "imp-riscas-colorida",
      "imp-risca-azul",
      "imp-vichy-verde",
      "imp-brinquedos"
    ],
    "images": [
      {
        "id": "static:pc1",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc2",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc3",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc4",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc5",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc6",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc7",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc8",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc9",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc10",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc11",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc12",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc13",
        "alt": "Porta-chupetas em forma de ursinho"
      },
      {
        "id": "static:pc14",
        "alt": "Porta-chupetas em forma de ursinho"
      }
    ],
    "features": [],
    "availability": {
      "type": "encomenda"
    },
    "price": 14,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": "Tamanho adaptado a todas as chupetas",
    "featured": true,
    "options": [
      {
        "id": "nome-ursinho",
        "label": "Nome no ursinho",
        "hint": null,
        "choices": [
          {
            "id": "sem-nome",
            "label": "Sem nome",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "com-nome",
            "label": "Com nome",
            "priceDelta": 1.0,
            "textLabel": "Nome no ursinho",
            "textMaxLength": 12,
            "blockedByPattern": true
          }
        ]
      },
      {
        "id": "fita",
        "label": "Comprimento da fita",
        "hint": null,
        "choices": [
          {
            "id": "curta",
            "label": "Curta (20 cm)",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "comprida",
            "label": "Comprida (25 cm)",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          }
        ]
      },
      {
        "id": "prendedor",
        "label": "Prendedor",
        "hint": null,
        "choices": [
          {
            "id": "madeira",
            "label": "Madeira",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "plastico",
            "label": "Plástico",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          }
        ]
      },
      {
        "id": "nome-fita",
        "label": "Nome na fita",
        "hint": null,
        "choices": [
          {
            "id": "nao",
            "label": "Sem nome na fita",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "sim",
            "label": "Com nome na fita",
            "priceDelta": 0.5,
            "textLabel": "Nome na fita",
            "textMaxLength": 12,
            "blockedByPattern": true
          }
        ]
      },
      {
        "id": "adaptacao",
        "label": "Adaptação da fita à chupeta",
        "hint": "Com botão, confirma que a tua chupeta tem espaço para o tecido passar.",
        "choices": [
          {
            "id": "botao",
            "label": "Botão",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "fio",
            "label": "Fio",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          }
        ]
      }
    ]
  },
  {
    "slug": "babete-flor",
    "name": "Babete flor",
    "category": "babetes",
    "shape": "flor",
    "description": "Babete para baba com contorno em forma de flor, em algodão com interior impermeável. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa",
      "musselina-florzinhas",
      "musselina-flores",
      "bordado-branco",
      "bordado-bege",
      "bordado-ingles",
      "fio-dourado",
      "margaridas",
      "waffle-branco",
      "waffle-bege",
      "waffle-rosa-bebe"
    ],
    "images": [
      {
        "id": "static:bf1",
        "alt": "Babete com contorno em forma de flor"
      },
      {
        "id": "static:bf2",
        "alt": "Babete com contorno em forma de flor"
      },
      {
        "id": "static:bf3",
        "alt": "Babete com contorno em forma de flor"
      },
      {
        "id": "static:bf4",
        "alt": "Babete com contorno em forma de flor"
      },
      {
        "id": "static:bf5",
        "alt": "Babete com contorno em forma de flor"
      }
    ],
    "features": [
      "Algodão com interior impermeável"
    ],
    "availability": {
      "type": "encomenda"
    },
    "price": 9,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": true,
    "options": REVERSIVEL_OPTIONS,
    "slots": REVERSIVEL_SLOTS
  },
  {
    "slug": "babete-lenco",
    "name": "Babete lenço",
    "category": "babetes",
    "shape": "redondo",
    "description": "Babete para baba em formato lenço, em algodão com interior impermeável. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa",
      "musselina-florzinhas",
      "musselina-flores",
      "bordado-branco",
      "bordado-bege",
      "bordado-ingles",
      "fio-dourado",
      "margaridas",
      "waffle-branco",
      "waffle-bege",
      "waffle-rosa-bebe"
    ],
    "images": [
      {
        "id": "static:bl1",
        "alt": "Babete em formato lenço"
      },
      {
        "id": "static:bl2",
        "alt": "Babete em formato lenço"
      },
      {
        "id": "static:bl3",
        "alt": "Babete em formato lenço"
      }
    ],
    "features": [
      "Algodão com interior impermeável"
    ],
    "availability": {
      "type": "encomenda"
    },
    "price": 9,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": false,
    "options": REVERSIVEL_OPTIONS,
    "slots": REVERSIVEL_SLOTS
  },

  {
    "slug": "pack-4-babetes",
    "slotsMode": "pack",
    "slots": [{ "id": "babete-1", "label": "Babete 1", "models": [{ "id": "flor", "label": "Flor" }, { "id": "lenco", "label": "Lenço" }], "patterns": [] }, { "id": "babete-2", "label": "Babete 2", "models": [{ "id": "flor", "label": "Flor" }, { "id": "lenco", "label": "Lenço" }], "patterns": [] }, { "id": "babete-3", "label": "Babete 3", "models": [{ "id": "flor", "label": "Flor" }, { "id": "lenco", "label": "Lenço" }], "patterns": [] }, { "id": "babete-4", "label": "Babete 4", "models": [{ "id": "flor", "label": "Flor" }, { "id": "lenco", "label": "Lenço" }], "patterns": [] }, ...PACK_BIB_VERSOS],
    "name": "Pack de 4 babetes",
    "category": "babetes",
    "shape": "flor",
    "description": "Pack de 4 babetes, em formato lenço e flor. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa",
      "musselina-florzinhas",
      "musselina-flores",
      "bordado-branco",
      "bordado-bege",
      "bordado-ingles",
      "fio-dourado",
      "margaridas",
      "waffle-branco",
      "waffle-bege",
      "waffle-rosa-bebe"
    ],
    "images": [
      {
        "id": "static:pb1",
        "alt": "Babetes em formato flor e lenço"
      },
      {
        "id": "static:pb2",
        "alt": "Babetes em formato flor e lenço"
      },
      {
        "id": "static:pb3",
        "alt": "Babetes em formato flor e lenço"
      },
      {
        "id": "static:pb4",
        "alt": "Babetes em formato flor e lenço"
      }
    ],
    "features": [
      "4 babetes"
    ],
    "availability": {
      "type": "encomenda"
    },
    "price": 32,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": false,
    "options": PACK_BIB_OPTIONS
  },
  {
    "slug": "tapa-fraldas-reversivel",
    "name": "Tapa-fraldas reversível",
    "category": "tapa-fraldas",
    "shape": "tapa",
    "description": "Tapa-fraldas reversível, com 2 padrões. Feito à mão por mim, por encomenda. Os tecidos waffle não estão disponíveis para tapa-fraldas.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa",
      "musselina-florzinhas",
      "musselina-flores",
      "bordado-branco",
      "bordado-bege",
      "bordado-ingles",
      "fio-dourado",
      "margaridas"
    ],
    "images": [
      {
        "id": "static:tf1",
        "alt": "Tapa-fraldas"
      },
      {
        "id": "static:tf2",
        "alt": "Tapa-fraldas"
      },
      {
        "id": "static:tf3",
        "alt": "Tapa-fraldas"
      },
      {
        "id": "static:tf4",
        "alt": "Tapa-fraldas"
      },
      {
        "id": "static:tf5",
        "alt": "Tapa-fraldas"
      }
    ],
    "features": [
      "Reversível (2 padrões)"
    ],
    "availability": {
      "type": "encomenda"
    },
    "price": 20,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": true,
    "options": [
      {
        "id": "tamanho",
        "label": "Tamanho",
        "hint": null,
        "choices": [
          { "id": "3-6m", "label": "3-6 meses", "priceDelta": 0.0, "textLabel": null, "textMaxLength": 12, "blockedByPattern": false },
          { "id": "6-9m", "label": "6-9 meses", "priceDelta": 0.0, "textLabel": null, "textMaxLength": 12, "blockedByPattern": false },
          { "id": "9-12m", "label": "9-12 meses", "priceDelta": 0.0, "textLabel": null, "textMaxLength": 12, "blockedByPattern": false },
          { "id": "12-18m", "label": "12-18 meses", "priceDelta": 0.0, "textLabel": null, "textMaxLength": 12, "blockedByPattern": false }
        ]
      }
    ]
  },
  {
    "slug": "porta-fraldas",
    "name": "Porta-fraldas",
    "category": "porta-fraldas",
    "shape": "carteira",
    "description": "Porta-fraldas para levar fraldas e toalhitas sempre à mão. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa"
    ],
    "images": [
      { "id": "static:p19", "alt": "Porta-fraldas aberto, com janela para os toalhetes" }
    ],
    "features": [],
    "availability": {
      "type": "encomenda"
    },
    "price": 24,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": true,
    "options": []
  },
  {
    "slug": "muda-fraldas-portatil",
    "slotsMode": "extra",
    "slots": [{ "id": "elastico", "label": "Fita (elástico)", "models": [], "patterns": [], "suggested": true, "suggestions": [{"patternId": "florzinhas-rosa", "slotPatternId": "vichy-rosa"}, {"patternId": "flores-rosa", "slotPatternId": "vichy-rosa-claro"}, {"patternId": "folhas-azuis", "slotPatternId": "vichy-azul"}, {"patternId": "folhas-rosa", "slotPatternId": "vichy-rosa"}, {"patternId": "flores-coloridas", "slotPatternId": "vichy-bege"}, {"patternId": "flores", "slotPatternId": "vichy-bege"}, {"patternId": "petalas-rosa", "slotPatternId": "vichy-rosa-claro"}, {"patternId": "vichy-bege", "slotPatternId": "riscas-bege"}, {"patternId": "vichy-azul", "slotPatternId": "riscas-finas-azuis"}, {"patternId": "riscas-bege", "slotPatternId": "vichy-bege"}] }],
    "name": "Muda-fraldas portátil",
    "category": "porta-fraldas",
    "shape": "carteira",
    "description": "Muda-fraldas portátil, com elástico para fechar. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa"
    ],
    "images": [
      {
        "id": "static:mf1",
        "alt": "Muda-fraldas portátil"
      },
      {
        "id": "static:mf2",
        "alt": "Muda-fraldas portátil"
      }
    ],
    "features": [],
    "availability": {
      "type": "encomenda"
    },
    "price": 12,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": false,
    "options": []
  },
  {
    "slug": "conjunto-porta-fraldas-muda-fraldas",
    "slotsMode": "extra",
    "slots": [{ "id": "elastico", "label": "Fita (elástico)", "models": [], "patterns": [], "suggested": true, "suggestions": [{"patternId": "florzinhas-rosa", "slotPatternId": "vichy-rosa"}, {"patternId": "flores-rosa", "slotPatternId": "vichy-rosa-claro"}, {"patternId": "folhas-azuis", "slotPatternId": "vichy-azul"}, {"patternId": "folhas-rosa", "slotPatternId": "vichy-rosa"}, {"patternId": "flores-coloridas", "slotPatternId": "vichy-bege"}, {"patternId": "flores", "slotPatternId": "vichy-bege"}, {"patternId": "petalas-rosa", "slotPatternId": "vichy-rosa-claro"}, {"patternId": "vichy-bege", "slotPatternId": "riscas-bege"}, {"patternId": "vichy-azul", "slotPatternId": "riscas-finas-azuis"}, {"patternId": "riscas-bege", "slotPatternId": "vichy-bege"}] }],
    "name": "Conjunto porta-fraldas e muda-fraldas",
    "category": "porta-fraldas",
    "shape": "carteira",
    "description": "Conjunto de porta-fraldas e muda-fraldas portátil. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa"
    ],
    "images": [
      {
        "id": "static:cj1",
        "alt": "Porta-fraldas e muda-fraldas em conjunto"
      },
      {
        "id": "static:cj2",
        "alt": "Porta-fraldas e muda-fraldas em conjunto"
      },
      {
        "id": "static:cj3",
        "alt": "Porta-fraldas e muda-fraldas em conjunto"
      }
    ],
    "features": [
      "Conjunto de 2 peças"
    ],
    "availability": {
      "type": "encomenda"
    },
    "price": 32,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": false,
    "options": []
  },
  {
    "slug": "porta-documentos",
    "slotsMode": "pack",
    "slots": [{ "id": "exterior", "label": "Padrão do exterior", "models": [], "patterns": ["vichy-bege", "algodao-bege"] }, { "id": "interior", "label": "Padrão do interior", "models": [], "patterns": ["forro-animais", "flores-coloridas", "flores"] }],
    "name": "Porta-documentos",
    "category": "porta-fraldas",
    "shape": "carteira",
    "description": "Porta-documentos. Feito à mão por mim, por encomenda.",
    "patterns": [
      "folhas-azuis",
      "folhas-rosa",
      "florzinhas-rosa",
      "flores-rosa",
      "petalas-rosa",
      "flores-coloridas",
      "flores",
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa",
      "algodao-bege",
      "forro-animais"
    ],
    "images": [
      {
        "id": "static:pd1",
        "alt": "Porta-documentos"
      }
    ],
    "features": [],
    "availability": {
      "type": "encomenda"
    },
    "price": 24,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": null,
    "featured": false,
    "options": []
  },
  {
    "slug": "saquinho-de-roupa",
    "slotsMode": "pack",
    "slots": [{ "id": "forro", "label": "Padrão do forro", "models": [], "patterns": [] }, { "id": "exterior", "label": "Padrão do exterior", "models": [], "patterns": ["algodao-bege", "vichy-bege", "vichy-azul", "vichy-rosa", "riscas-bege", "riscas-finas-azuis", "riscas-verde"] }],
    "name": "Saquinho de roupa personalizado",
    "category": "saquinhos",
    "shape": "bolsa",
    "description": "Saquinho de roupa personalizado com nome, forrado com tecido impermeável ou algodão. Tamanho: 25 de altura por 22 de largura. Feito à mão por mim, por encomenda.",
    "patterns": [
      "algodao-bege",
      "vichy-bege",
      "imp-flores",
      "imp-bolinhas-castanhas",
      "imp-tulipas",
      "imp-flores-nuvens",
      "imp-cogumelos",
      "imp-riscas-colorida",
      "imp-risca-azul",
      "imp-vichy-verde",
      "imp-brinquedos",
      "forro-arco-iris",
      "forro-rosa",
      "forro-animais"
    ],
    "images": [
      {
        "id": "static:sq1",
        "alt": "Saquinho de roupa personalizado"
      },
      {
        "id": "static:sq2",
        "alt": "Saquinho de roupa personalizado"
      },
      {
        "id": "static:sq3",
        "alt": "Saquinho de roupa personalizado"
      }
    ],
    "features": [],
    "availability": {
      "type": "encomenda"
    },
    "price": 15,
    "priceIsExample": false,
    "personalization": {
      "label": "Nome do bebé",
      "maxLength": 12,
      "zones": [
        { "id": "centro", "label": "Ao centro" },
        { "id": "cima", "label": "Em cima" },
        { "id": "baixo", "label": "Em baixo" }
      ]
    },
    "dimensions": "25 de altura x 22 de largura",
    "featured": false,
    "options": []
  },
  {
    "slug": "pack-3-saquinhos",
    "slotsMode": "pack",
    "slots": [{ "id": "saquinho-1", "label": "Saquinho 1", "models": [], "patterns": [] }, { "id": "saquinho-2", "label": "Saquinho 2", "models": [], "patterns": [] }, { "id": "saquinho-3", "label": "Saquinho 3", "models": [], "patterns": [] }],
    "name": "Pack de 3 saquinhos de roupa",
    "category": "saquinhos",
    "shape": "bolsa",
    "description": "Pack de 3 saquinhos de roupa, forrados com tecido impermeável ou algodão. Tamanho: 25 de altura por 22 de largura. Feito à mão por mim, por encomenda.",
    "patterns": [
      "vichy-bege",
      "algodao-bege",
      "imp-flores",
      "imp-bolinhas-castanhas",
      "imp-tulipas",
      "imp-flores-nuvens",
      "imp-cogumelos",
      "imp-riscas-colorida",
      "imp-risca-azul",
      "imp-vichy-verde",
      "imp-brinquedos",
      "forro-arco-iris",
      "forro-rosa",
      "forro-animais"
    ],
    "images": [
      {
        "id": "static:sq2",
        "alt": "Saquinhos de roupa"
      },
      {
        "id": "static:sq1",
        "alt": "Saquinhos de roupa"
      },
      {
        "id": "static:sq3",
        "alt": "Saquinhos de roupa"
      }
    ],
    "features": [
      "3 saquinhos"
    ],
    "availability": {
      "type": "encomenda"
    },
    "price": 40,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": "25 de altura x 22 de largura",
    "featured": false,
    "options": [
      {
        "id": "posicao-nome",
        "label": "Onde fica o nome",
        "hint": "Escolhe a zona do saquinho onde queres o nome personalizado.",
        "choices": [
          {
            "id": "centro",
            "label": "Ao centro",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "cima",
            "label": "Em cima",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "baixo",
            "label": "Em baixo",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          }
        ]
      }
    ]
  },
  {
    "slug": "coelhinho",
    "slotsMode": "extra",
    "slots": [{ "id": "orelhas", "label": "Padrão das orelhas", "models": [], "patterns": [] }, { "id": "gola", "label": "Padrão da gola", "models": [], "patterns": [] }],
    "name": "Coelhinho",
    "category": "coelhinhos",
    "shape": "flor",
    "description": "Coelhinho com cerca de 20 cm, com gola em tecido. Podes pedir o nome na orelha. Feito à mão por mim, por encomenda.",
    "patterns": [
      "vichy-bege",
      "vichy-grande-bege",
      "vichy-verde-azul",
      "vichy-verde-tropa",
      "vichy-azul",
      "vichy-rosa",
      "vichy-rosa-claro",
      "vichy-cereja",
      "riscas-bege",
      "riscas-verde",
      "riscas-finas-azuis",
      "riscas-larga-azuis",
      "riscas-larga-verde-tropa"
    ],
    "images": [
      {
        "id": "static:co1",
        "alt": "Coelhinho Babybib"
      },
      {
        "id": "static:co2",
        "alt": "Coelhinho Babybib"
      },
      {
        "id": "static:co3",
        "alt": "Coelhinho Babybib"
      },
      {
        "id": "static:co4",
        "alt": "Coelhinho Babybib"
      },
      {
        "id": "static:co5",
        "alt": "Coelhinho Babybib"
      }
    ],
    "features": [],
    "availability": {
      "type": "encomenda"
    },
    "price": 17,
    "priceIsExample": false,
    "personalization": null,
    "dimensions": "Aproximadamente 20 cm",
    "featured": false,
    "options": [
      {
        "id": "nome-orelha",
        "label": "Nome na orelha",
        "hint": null,
        "choices": [
          {
            "id": "sem-nome",
            "label": "Sem nome",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "com-nome",
            "label": "Com nome",
            "priceDelta": 1.0,
            "textLabel": "Nome na orelha",
            "textMaxLength": 12,
            "blockedByPattern": true
          }
        ]
      },
      {
        "id": "orelha-nome",
        "label": "Orelha do nome",
        "hint": "Só conta se escolheres nome na orelha.",
        "choices": [
          {
            "id": "esquerda",
            "label": "Orelha esquerda",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          },
          {
            "id": "direita",
            "label": "Orelha direita",
            "priceDelta": 0.0,
            "textLabel": null,
            "textMaxLength": 12,
            "blockedByPattern": false
          }
        ]
      }
    ]
  }
].map((p) => ({ ...base, materials: materialsOf(p), ...p }));

// Ursinho e fita vendidos à parte (além do conjunto): mesmos tecidos, só com as opções de cada peça.
const pc = products.find((p) => p.slug === "porta-chupetas");
const pcOpts = (ids) => pc.options.filter((o) => ids.includes(o.id));
products.push(
  { ...pc, slug: "ursinho", name: "Ursinho (só o ursinho)", featured: false, price: 9, images: [], options: pcOpts(["nome-ursinho"]), features: [],
    description: "Só o ursinho do porta-chupetas, sem a fita. Feito à mão por mim, por encomenda, em algodão ou em tecido impermeável. Podes pedir o nome no ursinho. Nos tecidos bordados não é possível colocar nome." },
  { ...pc, slug: "fita-porta-chupetas", name: "Fita para porta-chupetas (só a fita)", featured: false, price: 5, images: [], options: pcOpts(["fita", "prendedor", "nome-fita", "adaptacao"]).map((o) => (o.id === "nome-fita" ? { ...o, choices: o.choices.map((c) => (c.id === "sim" ? { ...c, priceDelta: 1 } : c)) } : o)), features: [],
    description: "Só a fita do porta-chupetas, sem o ursinho. Escolhes o comprimento, o prendedor, se queres nome na fita e como se adapta à chupeta. Feita à mão por mim, por encomenda." },
);

export const faqs = [
  {
    "q": "As peças são feitas à mão?",
    "a": "Sim. Todas as peças Babybib são feitas à mão por mim."
  },
  {
    "q": "Que produtos posso personalizar?",
    "a": "Todos os artigos podem ser personalizados com o nome do teu bebé. Apenas o tecido waffle e a musselina bordada não permitem personalização."
  },
  {
    "q": "Como é personalizado o nome?",
    "a": "A personalização dos artigos é feita com vinil térmico. Resistente às lavagens."
  },
  {
    "q": "Há peças em stock?",
    "a": "Não! Todas as peças são feitas por encomenda para o teu bebé. Cada encomenda é criada por ordem de pedido, por isso aconselho-te a encomendares com antecedência."
  },
  {
    "q": "Quanto tempo demora uma encomenda?",
    "a": "Depende do tempo de produção e do número de encomendas. Os prazos vão ser confirmados por mim e indicados junto de cada produto."
  },
  {
    "q": "Para onde enviam e qual o valor dos portes?",
    "a": "Envio apenas para Portugal. Portes grátis em encomendas a partir de 100 €. Os custos de envio serão apresentados antes do pagamento."
  },
  {
    "q": "Que cuidados devo ter ao lavar as peças?",
    "a": "Recomendo lavar todos os artigos à mão, para maior durabilidade. Não colocar na máquina de secar."
  }
];
